// Generated by app/services/generate_js_env.rb

const railsEnv = {
  "API_CABLE_URL": "wss://stagingapi.wooftech.dk/cable",
  "API_URL": "https://stagingapi.wooftech.dk",
  "PEAKFLOW_JS_AUTH_TOKEN": "9PbrMkhEJqLu5txuRWPy1MRcxJBgfRQ4wnh4UVBtxLLQDA3mFLnWyGDyhe4Fotxzoc6JB6bwZNCTk7rLueLYg8iotMRNpFgi1ZbK",
  "PLAY_DOMAIN": "staging.letswoof.io",
  "PLAY_DOMAIN_DA": "staging.wooftech.dk",
  "PLAY_DOMAIN_EN": "staging.letswoof.io",
  "PLAY_DOMAIN_NO": "staging.startwoof.no",
  "PLAY_DOMAIN_SE": "staging.startwoof.se",
  "PRODUCTFRUIT_CODE": "",
  "RAILS_ENV": "staging"
}
const env = {}

for (const key in railsEnv) {
  env[key] = globalThis[key] || railsEnv[key]
}

export default env
